var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents3" }, [
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isMobile,
          expression: "!isMobile"
        }
      ],
      staticClass: "bg",
      attrs: { src: "static/img/service/site_service_img_03.png" }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isMobile,
            expression: "!isMobile"
          }
        ],
        staticClass: "contents"
      },
      [
        _c("div", { staticClass: "text" }, [
          _c("div", { staticClass: "wrap" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.gotoPage(
                        "https://www.carsuri.co.kr/intro?tab=1"
                      )
                    }
                  }
                },
                [_c("img", { attrs: { src: "static/img/service/btn.png" } })]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isMobile,
            expression: "isMobile"
          }
        ],
        staticClass: "contents"
      },
      [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _c("img", {
            attrs: { src: "static/img/mobile/service/background_white_03.png" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "wrap" }, [
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.gotoPage(
                        "https://www.carsuri.co.kr/intro?tab=1"
                      )
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "static/img/mobile/service/btn.png" }
                  })
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "static/img/icon_repair.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v("카수리 "),
      _c("span", [_vm._v("타이어")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body" }, [
      _c("p", [_vm._v("타이어 교체도 카수리에서 해결하세요!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            1. 제조상의 결함이 없는 1년 이내 생산된 정품 타이어"
        ),
        _c("br"),
        _vm._v("\n            2. 전국 어디서나 동일한 가격!"),
        _c("br"),
        _vm._v("\n            3. 구매 후, 전국 무료 장착점에 방문만 하면 OK!"),
        _c("br")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: "static/img/mobile/service/site_service_img_03_m.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "static/img/mobile/service/icon_repair.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v("카수리 "),
      _c("span", [_vm._v("타이어")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body" }, [
      _c("p", [_vm._v("타이어 교체도 카수리에서 해결하세요!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n            1. 제조상의 결함이 없는 1년 이내 생산된"),
        _c("br"),
        _vm._v(" "),
        _c("span", { staticStyle: { "margin-left": "3.7%" } }, [
          _vm._v("정품 타이어")
        ]),
        _c("br"),
        _vm._v("\n            2. 전국 어디서나 동일한 가격!"),
        _c("br"),
        _vm._v("\n            3. 구매 후, 전국 무료 장착점에 방문만 하면 OK!"),
        _c("br")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-361f1aba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361f1aba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/service/Contents3.vue
// module id = null
// module chunks = 